import * as Yup from 'yup'

const mediaInputSchema = Yup.object().shape({
  title: Yup.string().required('validation-required'),
  link: Yup.string().required('validation-required'),
  file: Yup.array().optional().nullable(),
})

export { mediaInputSchema }
